import { useTranslation } from 'react-i18next';
import { Dialog, DialogHeader } from 'components/dialog/dialog';
import {
  CancelStopButton,
  ConfirmStopButton,
  ConfirmStopIcon,
  StopDialogContent,
  StopDialogDescription,
  StopDialogFooter,
  StopDialogTitle,
} from './PatientSyncStopDialog.styles';

interface PatientSyncStopDialogProps {
  onConfirm: () => void;
  onClose: () => void;
}

export function PatientSyncStopDialog({ onConfirm, onClose }: PatientSyncStopDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <StopDialogContent>
        <DialogHeader>
          <StopDialogTitle>{t('patientSync.stopDialog.title')}</StopDialogTitle>
        </DialogHeader>
        <StopDialogDescription>{t('patientSync.stopDialog.description')}</StopDialogDescription>
        <StopDialogFooter>
          <CancelStopButton onClick={onClose}>{t('cancel')}</CancelStopButton>
          <ConfirmStopButton onClick={onConfirm}>
            <ConfirmStopIcon />
            {t('patientSync.stopDialog.confirm')}
          </ConfirmStopButton>
        </StopDialogFooter>
      </StopDialogContent>
    </Dialog>
  );
}
